import Header from './components/Header';
import ProductScan from './components/ProductScan';
import { Navigate } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route,Switch } from 'react-router-dom';
import PurchaseOrder from './components/PurchaseOrder';
import PayOrder from './components/PayOrder';
// import InventoryManagementSystem from './components/InventoryManagementSystem';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import ManageCustomer from './components/ManageCustomer';
import ManageItems from './components/ManageItems';
import SalesReport from './components/SalesReport';
import ManageUsers from './components/ManageUsers';


// const user = JSON.parse(localStorage.getItem("user"));

// const roleRedirectMap = {
//   "1": "/sales-report",
//   "2": "/purchase-order",
// };

function App() {
  return (
    <div className="App">
      <Header/>
      <Router>
        <Routes>
          {/* <Route path="/" element={<Navigate to="/user" />} />
          <Route path="/user" element={<Login />} /> */}

          <Route path={"/user"}
            element={
              // user ? (
                // <Navigate to={roleRedirectMap[user.role]}
                // replace
                // />
              // ) : (
              <Login />
            // )
            }
          />
          <Route path={"/"}
            element={
              // user ? (<Navigate to={roleRedirectMap[user.role]} />) : (
            <Navigate to="/user" />
          // )
        }
          />
          <Route path="/productentry" element={
            <ProtectedRoute roles={["1", "2"]}>
              <ProductScan />
            </ProtectedRoute>
          } />
          <Route path="/purchase-order" element={
            <ProtectedRoute roles={["1", "2"]}>
              <PurchaseOrder />
            </ProtectedRoute>
          } />
          <Route path="/payorder" element={
            <ProtectedRoute roles={["1"]}>
              <PayOrder />
            </ProtectedRoute>
          } />
          {/* <Route path="/inventory-management" element={
            <ProtectedRoute roles={["1"]}>
              <InventoryManagementSystem />
            </ProtectedRoute>
          } /> */}
          <Route path="/manage-items" element={
            <ProtectedRoute roles={["1"]}>
              <ManageItems />
            </ProtectedRoute>
          } />
          <Route path="/manage-customers" element={
            <ProtectedRoute roles={["1"]}>
              <ManageCustomer />
            </ProtectedRoute>
          } />
          <Route path="/manage-users" element={
            <ProtectedRoute roles={["1"]}>
              <ManageUsers />
            </ProtectedRoute>
          } />
          <Route path="/sales-report" element={
            <ProtectedRoute roles={["1"]}>
              <SalesReport />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
